import React, { useState } from "react";
import Stepper from "../../components/Stepper";
import { Button } from "react-bootstrap";
import StoresPreviewList from "./StoresPreveiwList";
import { FORM_FIELDS } from "../../Constants";
import useFetcher from "../../../../Hooks/useFetcher";
import { globalServices } from "../../../../Services";
import AddStoreModal from "./AddStoreModal";
import "./index.css";

const StoreData = ({ stepState, previousPage, nextPage, formData }) => {
  const { STORE_DATA } = FORM_FIELDS;

  const { data: postOffices } = useFetcher({
    fetcher: globalServices.getPostOffices,
  });

  const [stores, setStores] = useState(formData[STORE_DATA.name] || []);
  const [showAddPosModal, setShowAddPosModal] = useState(false);
  const [posModalUpdateData, setPosModalUpdateData] = useState(null);

  const onNextPage = async () => {
    nextPage({ [STORE_DATA.name]: stores });
  };

  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          <h1 className="my-4 text-center">Upute</h1>
          <p>
            Ukoliko želite dodati prodajno mjesto, molimo pripremte podatke o
            prodajnom mjestu, interni akt sa kojim se propisiju podaci vezani za
            prodajno mjesto.
          </p>
          <p>
            Modul dozvoljava kreiranja prodajnog mjesta, te dodjeljivanje
            pripadajućih blagajni na prodajna mjesta.
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <Button
            onClick={() => {
              setShowAddPosModal(true);
            }}
          >
            Dodaj prodajno mjesto
          </Button>
          <p></p>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <h4>Lista prodajnih mjesta</h4>
          <StoresPreviewList
            stores={stores}
            setStores={setStores}
            showPriceListTable={false}
            showUpdateModal={(data) => {
              setShowAddPosModal(true);
              setPosModalUpdateData(data);
            }}
          />
        </div>
        <div className="col-lg-4"></div>
      </div>

      <Stepper
        stepState={stepState}
        previousPage={previousPage}
        nextPage={onNextPage}
      />

      <AddStoreModal
        show={showAddPosModal}
        postOffices={postOffices}
        updateData={posModalUpdateData}
        setStores={setStores}
        stores={stores}
        onHide={() => {
          setShowAddPosModal(false);
          setPosModalUpdateData();
        }}
      />
    </>
  );
};

export default StoreData;
